<template>
    <div :class="{'kb-mobile-header': true, 'kb-mobile-header--fixed': showOverlay}">
        <section class="kb-mobile-header__top">
            <div class="kb-mobile-header__logo">
                <a href="/">
                <kb-base-logo-s />
                </a>
            </div>
            <div class="kb-mobile-header__burger">
                <kb-base-hamburger @activated="showOverlay = true" @inactivated="showOverlay = false"></kb-base-hamburger>
            </div>
        </section>
        <section class="kb-mobile-header__overlay" v-if="showOverlay">
            <div class="kb-mobile-header__overlayinner">
                <kb-mobile-navigation-items :items="navigationItems" />
                <kb-mobile-login-bar
                    :login-url="loginUrl"
                    :logout-url="logoutUrl"
                    :register-url="registerUrl"
                    :profile-url="profileUrl"
                    :is-authenticated="isAuthenticated" />
            </div>
        </section>

        <section class="kb-mobile-header__search">
            <kb-recipe-search-input placeholder="Rezept suchen" :suggest-limit=5 :target-host="searchTargetHost"></kb-recipe-search-input>
        </section>

    </div>
</template>

<script>
import BaseLogoS from '@/components/Atoms/BaseLogoS/BaseLogoS'
import BaseHamburger from '@/components/Atoms/BaseHamburger/BaseHamburger'
import RecipeSearchInput from '@/components/Molecules/RecipeSearchInput/RecipeSearchInput'
import MobileNavigationItems from '@/components/Molecules/MobileNavigationItems/MobileNavigationItems'
import KbMobileLoginBar from "../../Molecules/MobileLoginBar/MobileLoginBar";

export default {
    name: "kb-mobile-header",
    props: {
        loginUrl: {
            type: String,
            default: 'https://sso.kochbar.de/login',
        },
        logoutUrl: {
            type: String,
            default: 'https://sso.kochbar.de/logout',
        },
        registerUrl: {
            type: String,
            default: 'https://sso.kochbar.de/register'
        },
        searchTargetHost: {
            type: String
        },
        profileUrl: {
            type: String,
        },
        isAuthenticated: {
            type: Boolean,
            default: false
        },
        navigationItems: {
            required: true,
            type: Array
        }
    },
    components: {
        KbMobileLoginBar,
        BaseLogoS,
        BaseHamburger,
        RecipeSearchInput,
        MobileNavigationItems
    },
    data: function() {
        return {
            showOverlay: false
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors';

.kb-mobile-header {
    position: relative;
    box-sizing: border-box;
    margin: .625rem 0 .625rem 0;
    width: 100%;
    background-color: $cBGPrimary;
    z-index: 1000;

    &__top {
        margin: 0 1.5rem .75rem 1.5rem;
        display: flex;
        justify-content: space-between;
    }

    &__logo {
        padding-top: 0.8rem;
    }

    &__burger .hamburger {
        padding: 0;
        margin-top: 1.2rem;
    }

    &__search {
        margin: 0 .625rem  1.5rem .625rem;
    }

    &__overlay {
        background-color: $cBGPrimary;
    }

    &__overlayinner {
        margin: .625rem 1.5rem 0 1.5rem;

        .kb-mobile-login-bar {
            margin: 0 0 1.5rem 0;

            .kb-mobile-login-bar__loginlinkicon {
                line-height: 1.3em;
            }
        }
    }

}

</style>
